import { get, put } from 'utils/fetch';
import { CURRENCY_EXCHANGE_RATES_URL } from 'constants/Jaws';

export const getCurrency = async currency => {
  const response = await get(`${CURRENCY_EXCHANGE_RATES_URL}/${currency}`);

  if (!response.ok) throw response;

  return await response.json();
};

export const getCurrencySupplementCharges = async currency => {
  const response = await get(
    `${CURRENCY_EXCHANGE_RATES_URL}/${currency}/supplement-charges`,
  );

  if (!response.ok) throw response;

  return await response.json();
};

export const setCurrencySupplementCharges = async (currency, data) => {
  const response = await put(
    `${CURRENCY_EXCHANGE_RATES_URL}/${currency}`,
    JSON.stringify(data),
  );

  if (!response.ok) throw response;
};
